import { keyframes } from "tss-react";
import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material/styles";

const fadeInUp = keyframes({
    from: {
        opacity: 0,
        transform: "translateY(8px)",
    },
    to: {
        opacity: 1,
        transform: "translateY(0)",
    },
});

export const useWorkspaceClaimStyles = makeStyles()((theme: Theme) => ({
    container: {
        maxWidth: 920,
        width: "100%",
        margin: "0 auto",
        padding: theme.spacing(2, 0),
    },
    content: {
        display: "flex",
        flexDirection: "column",
    },
    titleContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: theme.spacing(2),
    },
    languageSwitcher: {
        width: theme.spacing(40),
        maxWidth: "100%",
    },
    description: {
        color: theme.palette.emteria.text.primary,
        textAlign: "center",
        maxWidth: 920,
        alignSelf: "center",
        marginTop: theme.spacing(2.5),
    },
    cardList: {
        display: "grid",
        gap: theme.spacing(3.5),
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
        marginTop: theme.spacing(5),
    },
    optionCard: {
        position: "relative",
        "&:hover img": {
            transform: "scale(1.08)",
        },
    },
    optionImageWrapper: {
        position: "relative",
        width: "100%",
        height: 275,
        overflow: "hidden",
    },
    optionImage: {
        width: "100%",
        height: 275,
        objectFit: "cover",
        display: "block",
        transition: "transform 0.4s ease",
    },
    optionBody: {
        padding: theme.spacing(3.5, 4),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
    },
    optionPlan: {
        lineHeight: 1.5,
        color: theme.palette.emteria.text.secondary,
    },
    optionTitle: {
        fontWeight: 700,
        color: theme.palette.emteria.text.primary,
    },
    optionDescription: {
        color: theme.palette.emteria.text.secondary,
        lineHeight: 1.5,
    },
    indicator: {
        position: "absolute",
        top: theme.spacing(1.5),
        right: theme.spacing(1.5),
        zIndex: 2,
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: `2px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.common.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.common.white,
        "& i": {
            fontSize: 14,
        },
    },
    indicatorSelected: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
    },
    inputBox: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "stretch",
        },
    },
    emailField: {
        flex: 1,
    },
    dynamicSection: {
        marginTop: theme.spacing(8),
        minHeight: 220,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
    },
    detailPanel: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(3),
        boxShadow: theme.shadows[1],
        animation: `${fadeInUp} 220ms ease-out`,
        animationFillMode: "backwards",
    },
    actionCenter: {
        display: "flex",
        justifyContent: "center",
        animation: `${fadeInUp} 220ms ease-out`,
        animationFillMode: "backwards",
    },
}));
